import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sonb" }
const _hoisted_2 = {
  class: "sonb__head",
  "data-tour": "seller-onboarding-intro"
}
const _hoisted_3 = {
  class: "sonb__steps",
  "aria-label": "진행 단계"
}
const _hoisted_4 = { class: "sonb__step-num" }
const _hoisted_5 = { class: "sonb__step-label" }
const _hoisted_6 = {
  key: 0,
  class: "sonb__error"
}
const _hoisted_7 = { class: "sonb__layout" }
const _hoisted_8 = {
  key: 0,
  id: "sonb-password",
  class: "sui-card sonb__section",
  "data-tour": "seller-onboarding-password"
}
const _hoisted_9 = { class: "sui-card__head sonb__section-head" }
const _hoisted_10 = {
  class: "sonb__section-num",
  "aria-hidden": "true"
}
const _hoisted_11 = { class: "sui-card__title" }
const _hoisted_12 = { class: "sui-card__body sonb__body" }
const _hoisted_13 = { class: "sui-row sonb__row" }
const _hoisted_14 = { class: "sui-field" }
const _hoisted_15 = { class: "sui-field" }
const _hoisted_16 = {
  id: "sonb-profile",
  class: "sui-card sonb__section",
  "data-tour": "seller-onboarding-profile"
}
const _hoisted_17 = { class: "sui-card__head sonb__section-head" }
const _hoisted_18 = {
  class: "sonb__section-num",
  "aria-hidden": "true"
}
const _hoisted_19 = { class: "sui-card__title" }
const _hoisted_20 = { class: "sui-card__body sonb__body" }
const _hoisted_21 = { class: "sui-row sonb__row" }
const _hoisted_22 = { class: "sui-field" }
const _hoisted_23 = { class: "sui-field" }
const _hoisted_24 = { class: "sui-row sonb__row" }
const _hoisted_25 = { class: "sui-field" }
const _hoisted_26 = { class: "sui-field" }
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  key: 0,
  class: "sui-hint sonb__verify-err"
}
const _hoisted_29 = {
  key: 1,
  class: "sui-hint sonb__verify-ok"
}
const _hoisted_30 = {
  key: 2,
  class: "sui-hint"
}
const _hoisted_31 = { class: "sui-field" }
const _hoisted_32 = { class: "sui-field" }
const _hoisted_33 = { class: "sonb__inline" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "sui-hint sonb__verify-ok"
}
const _hoisted_37 = {
  key: 1,
  class: "sui-hint sonb__verify-ok"
}
const _hoisted_38 = {
  key: 2,
  class: "sui-hint"
}
const _hoisted_39 = {
  key: 0,
  class: "sui-field"
}
const _hoisted_40 = { class: "sonb__inline" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = {
  key: 0,
  class: "sonb__timer"
}
const _hoisted_43 = { class: "sui-field" }
const _hoisted_44 = { class: "sonb__inline" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = {
  key: 0,
  class: "sui-hint sonb__verify-ok"
}
const _hoisted_48 = {
  key: 1,
  class: "sui-hint"
}
const _hoisted_49 = {
  key: 1,
  class: "sui-field"
}
const _hoisted_50 = { class: "sonb__inline" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 0,
  class: "sonb__timer"
}
const _hoisted_53 = { class: "sui-row sonb__row" }
const _hoisted_54 = { class: "sui-field" }
const _hoisted_55 = { class: "sonb__inline" }
const _hoisted_56 = ["value"]
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { class: "sui-field" }
const _hoisted_59 = ["value"]
const _hoisted_60 = { class: "sui-field" }
const _hoisted_61 = {
  id: "sonb-bank",
  class: "sui-card sonb__section",
  "data-tour": "seller-onboarding-bank"
}
const _hoisted_62 = { class: "sui-card__head sonb__section-head" }
const _hoisted_63 = {
  class: "sonb__section-num",
  "aria-hidden": "true"
}
const _hoisted_64 = { class: "sui-card__title" }
const _hoisted_65 = { class: "sui-card__body sonb__body" }
const _hoisted_66 = { class: "sui-row sonb__row" }
const _hoisted_67 = { class: "sui-field" }
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "sui-field" }
const _hoisted_70 = { class: "sui-field" }
const _hoisted_71 = {
  id: "sonb-terms",
  class: "sui-card sonb__section",
  "data-tour": "seller-onboarding-terms"
}
const _hoisted_72 = { class: "sui-card__head sonb__section-head" }
const _hoisted_73 = {
  class: "sonb__section-num",
  "aria-hidden": "true"
}
const _hoisted_74 = { class: "sui-card__title" }
const _hoisted_75 = { class: "sui-card__body sonb__body" }
const _hoisted_76 = {
  key: 0,
  class: "sonb__check sonb__check--all"
}
const _hoisted_77 = { class: "sonb__doc-body" }
const _hoisted_78 = ["onUpdate:modelValue"]
const _hoisted_79 = {
  key: 1,
  class: "sonb__empty"
}
const _hoisted_80 = {
  id: "sonb-contract",
  class: "sui-card sonb__section",
  "data-tour": "seller-onboarding-contract"
}
const _hoisted_81 = { class: "sui-card__head sonb__section-head" }
const _hoisted_82 = {
  class: "sonb__section-num",
  "aria-hidden": "true"
}
const _hoisted_83 = { class: "sui-card__title" }
const _hoisted_84 = { class: "sui-card__body sonb__body" }
const _hoisted_85 = {
  key: 0,
  class: "sonb__empty"
}
const _hoisted_86 = {
  id: "sonb-signature",
  class: "sui-card sonb__section",
  "data-tour": "seller-onboarding-signature"
}
const _hoisted_87 = { class: "sui-card__head sonb__section-head" }
const _hoisted_88 = {
  class: "sonb__section-num",
  "aria-hidden": "true"
}
const _hoisted_89 = { class: "sui-card__title" }
const _hoisted_90 = { class: "sui-card__body sonb__body" }
const _hoisted_91 = {
  id: "sonb-submit",
  class: "sonb__actions",
  "data-tour": "seller-onboarding-submit"
}
const _hoisted_92 = ["disabled"]
const _hoisted_93 = {
  class: "sonb__tracker",
  "data-tour": "seller-onboarding-tracker",
  "aria-label": "입력 확인"
}
const _hoisted_94 = { class: "sonb__tracker-card" }
const _hoisted_95 = { class: "sonb__tracker-head" }
const _hoisted_96 = { class: "sonb__tracker-list" }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = {
  class: "sonb__tracker-mark",
  "aria-hidden": "true"
}
const _hoisted_99 = { class: "sonb__tracker-label" }

import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import SignaturePad from '@/components/common/SignaturePad.vue'
import ContractDocumentView, {
  type ContractCheckProgress,
} from '@/components/seller/ContractDocumentView.vue'
import { fetchSellerOnboarding, submitSellerOnboarding, type SellerLegalDoc } from '@/api/seller'
import { useSellerAuth } from '@/composables/useSellerAuth'
import { useDaumPostcode } from '@/composables/useDaumPostcode'
import { useContentSnippets, SNIPPET_FALLBACKS } from '@/composables/useContentSnippets'
import { useVerification } from '@/composables/useVerification'
import { MALL_BANKS } from '@/constants/banks'
import {
  bizNumberInputError,
  formatBizNumberInput,
  isBizNumberInputValid,
  isEmailValid,
  isPhoneValid,
  isVerifyCodeValid,
  sanitizeDigitsInput,
} from '@/utils/formValidation'
import { blobToBase64, buildContractPdfBlob } from '@/utils/contractPdf'

type ChecklistItem = {
  key: string
  label: string
  done: boolean
  target: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SellerOnboardingPage',
  setup(__props) {

const router = useRouter()
const { setSeller, seller } = useSellerAuth()
const { opening: postcodeOpening, searchPostcode } = useDaumPostcode()
const { loadSnippets, snippet } = useContentSnippets()
const emailVerification = useVerification('seller-onboarding')
const phoneVerification = useVerification('seller-onboarding')

const BANKS = MALL_BANKS
const docs = ref<SellerLegalDoc[]>([])
const intro = ref(SNIPPET_FALLBACKS['seller.onboard.intro'])
const pwTemp = ref(false)
const errorMessage = ref('')
const submitting = ref(false)
const signature = ref('')
const acceptAllTerms = ref(false)
const accepted = reactive<Record<string, boolean>>({})
/** 계약서 섹션·전자계약·최종 동의별 진행 (리모컨용) */
const contractCheckMap = reactive<Record<string, ContractCheckProgress[]>>({})

const termDocs = computed(() => docs.value.filter((doc) => doc.kind !== 'CONTRACT'))
const contractDocs = computed(() => docs.value.filter((doc) => doc.kind === 'CONTRACT'))

const form = reactive({
  storeName: '',
  bizName: '',
  bizNumber: '',
  ownerName: '',
  managerName: '',
  email: '',
  emailCode: '',
  phone: '',
  phoneCode: '',
  zipcode: '',
  address: '',
  addressDetail: '',
  settleBank: '',
  settleAccount: '',
  settleHolder: '',
  newPassword: '',
  newPasswordConfirm: '',
})

const emailLocked = computed(
  () => emailVerification.sending || emailVerification.verified,
)
const phoneLocked = computed(
  () => phoneVerification.sending || phoneVerification.verified,
)

const bizNumberError = computed(() => bizNumberInputError(form.bizNumber))

function onBizNumberInput(event: Event) {
  const raw = (event.target as HTMLInputElement).value
  /* 숫자만 붙여넣어도 하이픈을 바로 넣어 000-00-00000 으로 맞춘다 */
  form.bizNumber = formatBizNumberInput(raw)
}

const termsAccepted = computed(
  () => termDocs.value.length > 0 && termDocs.value.every((doc) => accepted[doc.code]),
)
const contractAccepted = computed(
  () =>
    contractDocs.value.length > 0 && contractDocs.value.every((doc) => accepted[doc.code]),
)

const checklist = computed<ChecklistItem[]>(() => {
  const items: ChecklistItem[] = []

  if (pwTemp.value) {
    items.push({
      key: 'password',
      label: '새 비밀번호',
      done: form.newPassword.length >= 8,
      target: 'ob-pw',
    })
    items.push({
      key: 'passwordConfirm',
      label: '비밀번호 확인',
      done:
        form.newPasswordConfirm.length >= 8 &&
        form.newPasswordConfirm === form.newPassword,
      target: 'ob-pw2',
    })
  }

  items.push(
    {
      key: 'storeName',
      label: '업체명',
      done: Boolean(form.storeName.trim()),
      target: 'ob-store',
    },
    {
      key: 'ownerName',
      label: '대표자명',
      done: Boolean(form.ownerName.trim()),
      target: 'ob-owner',
    },
    {
      key: 'bizName',
      label: '상호',
      done: Boolean(form.bizName.trim()),
      target: 'ob-biz',
    },
    {
      key: 'bizNumber',
      label: '사업자등록번호',
      done: isBizNumberInputValid(form.bizNumber),
      target: 'ob-bizno',
    },
    {
      key: 'managerName',
      label: '담당자명',
      done: Boolean(form.managerName.trim()),
      target: 'ob-manager',
    },
    {
      key: 'email',
      label: '이메일 인증',
      done: emailVerification.verified,
      target: 'ob-email',
    },
    {
      key: 'phone',
      label: '휴대폰 인증',
      done: phoneVerification.verified,
      target: 'ob-phone',
    },
    {
      key: 'address',
      label: '출고지 주소',
      done: Boolean(form.zipcode && form.address),
      target: 'ob-zip',
    },
    {
      key: 'bank',
      label: '정산 은행',
      done: Boolean(form.settleBank),
      target: 'ob-bank',
    },
    {
      key: 'account',
      label: '계좌번호',
      done: Boolean(form.settleAccount.replace(/\D/g, '')),
      target: 'ob-acc',
    },
    {
      key: 'holder',
      label: '예금주',
      done: Boolean(form.settleHolder.trim()),
      target: 'ob-holder',
    },
    {
      key: 'terms',
      label: '약관 동의',
      done: termsAccepted.value,
      target: 'sonb-terms',
    },
  )

  for (const doc of contractDocs.value) {
    const checks = contractCheckMap[doc.code] || []
    for (const check of checks) {
      items.push({
        key: `contract-${doc.code}-${check.key}`,
        label: check.label,
        done: check.done,
        target: check.target,
      })
    }
  }

  items.push({
    key: 'signature',
    label: '서명',
    done: Boolean(signature.value),
    target: 'sonb-signature',
  })

  return items
})

const checklistDoneCount = computed(() => checklist.value.filter((item) => item.done).length)

function scrollToChecklistItem(item: ChecklistItem) {
  const el = document.getElementById(item.target)
  if (!el) return
  el.scrollIntoView({ behavior: 'smooth', block: 'center' })
  if (el instanceof HTMLElement) {
    el.classList.add('sonb__flash')
    window.setTimeout(() => el.classList.remove('sonb__flash'), 1200)
    if (el.matches('input, select, textarea, button')) {
      el.focus({ preventScroll: true })
    }
  }
}

const steps = computed(() => {
  const list = [
    ...(pwTemp.value ? [{ key: 'password', label: '비밀번호' }] : []),
    { key: 'profile', label: '사업자 정보' },
    { key: 'bank', label: '정산 계좌' },
    { key: 'terms', label: '약관 동의' },
    { key: 'contract', label: '계약서' },
    { key: 'signature', label: '서명' },
  ]
  return list
})

const STEP_LABELS: Record<string, string> = {
  password: '임시 비밀번호 변경',
  profile: '사업자 · 담당자 · 출고지',
  bank: '정산 계좌',
  terms: '약관 동의',
  contract: '계약서 확인',
  signature: '서명',
}

function stepIndex(key: string) {
  return steps.value.findIndex((step) => step.key === key) + 1
}

function stepLabel(key: string) {
  return STEP_LABELS[key] || key
}

function docEffective(doc: SellerLegalDoc) {
  return doc.effective || doc.version
}

function onSignature(dataUrl: string) {
  signature.value = dataUrl
}

function onAcceptAllTerms() {
  for (const doc of termDocs.value) {
    accepted[doc.code] = acceptAllTerms.value
  }
}

function onContractReady(code: string, ready: boolean) {
  accepted[code] = ready
}

function onContractChecks(code: string, items: ContractCheckProgress[]) {
  contractCheckMap[code] = items
}

watch(
  () => termDocs.value.map((doc) => accepted[doc.code]),
  (flags) => {
    acceptAllTerms.value = flags.length > 0 && flags.every(Boolean)
  },
)

async function onSearchAddress() {
  try {
    const result = await searchPostcode()
    if (!result) return
    form.zipcode = result.zipcode
    form.address = result.extra ? `${result.address} ${result.extra}` : result.address
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '주소 검색에 실패했습니다.')
  }
}

async function sendEmailCode() {
  form.emailCode = ''
  try {
    await emailVerification.sendEmail(form.email)
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '이메일 인증번호 발송에 실패했습니다.')
  }
}

async function confirmEmailCode() {
  try {
    await emailVerification.verifyEmail(form.email, form.emailCode)
  } catch {
    /* errorMessage는 폼에 표시 */
  }
}

async function sendPhoneCode() {
  form.phoneCode = ''
  try {
    await phoneVerification.sendPhone(form.phone)
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '문자 인증번호 발송에 실패했습니다.')
  }
}

async function confirmPhoneCode() {
  try {
    await phoneVerification.verifyPhone(form.phone, form.phoneCode)
  } catch {
    /* errorMessage는 폼에 표시 */
  }
}

watch(
  () => form.email,
  () => {
    form.emailCode = ''
    emailVerification.reset()
  },
)

watch(
  () => form.phone,
  () => {
    form.phoneCode = ''
    phoneVerification.reset()
  },
)

async function load() {
  errorMessage.value = ''
  try {
    await loadSnippets(['seller.onboard.intro'])
    const data = await fetchSellerOnboarding()
    docs.value = data.docs
    intro.value = data.intro || snippet('seller.onboard.intro')
    pwTemp.value = Boolean(data.seller.pwTemp)
    form.storeName = data.seller.storeName || ''
    form.bizName = data.seller.bizName || ''
    form.bizNumber = formatBizNumberInput(data.seller.bizNumber || '')
    form.ownerName = data.seller.ownerName || ''
    form.managerName = data.seller.managerName || ''
    form.email = data.seller.email || ''
    form.phone = data.seller.phone || ''
    form.zipcode = data.seller.zipcode || ''
    form.address = data.seller.address || ''
    form.addressDetail = data.seller.addressDetail || ''
    form.settleBank = data.seller.settleBank || ''
    form.settleAccount = data.seller.settleAccount || ''
    form.settleHolder = data.seller.settleHolder || ''
    for (const doc of data.docs) {
      accepted[doc.code] = false
    }
    if (!data.seller.mustOnboard) {
      await router.replace('/seller')
    }
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '온보딩 정보를 불러오지 못했습니다.'
  }
}

async function onSubmit() {
  if (pwTemp.value) {
    if (form.newPassword.length < 8) {
      window.alert('새 비밀번호는 8자 이상이어야 합니다.')
      return
    }
    if (form.newPassword !== form.newPasswordConfirm) {
      window.alert('새 비밀번호 확인이 일치하지 않습니다.')
      return
    }
  }
  if (!isBizNumberInputValid(form.bizNumber)) {
    window.alert(bizNumberError.value || '사업자등록번호 숫자 10자리를 입력해 주세요.')
    scrollToChecklistItem({
      key: 'bizNumber',
      label: '사업자등록번호',
      done: false,
      target: 'ob-bizno',
    })
    return
  }
  if (!emailVerification.verified) {
    window.alert('이메일 인증을 완료해 주세요.')
    return
  }
  if (!phoneVerification.verified) {
    window.alert('휴대폰 인증을 완료해 주세요.')
    return
  }
  for (const doc of termDocs.value) {
    if (!accepted[doc.code]) {
      window.alert(`「${doc.title}」에 동의해 주세요.`)
      return
    }
  }
  if (!contractDocs.value.length) {
    window.alert('확인할 계약서가 없습니다. 관리자에게 문의해 주세요.')
    return
  }
  for (const doc of contractDocs.value) {
    if (!accepted[doc.code]) {
      window.alert('계약서 각 섹션·전자계약·최종 동의에 모두 체크해 주세요.')
      return
    }
  }
  if (!signature.value) {
    window.alert('서명란에 서명해 주세요.')
    return
  }
  if (!form.zipcode || !form.address) {
    window.alert('출고지 주소를 검색해 입력해 주세요.')
    return
  }

  submitting.value = true
  try {
    /* 계약서는 제출 시 PDF를 만들어 서버에 체결 스냅샷으로 보관한다 */
    const accepts: Array<{ code: string; version: string; pdfBase64?: string }> = []
    for (const doc of docs.value) {
      const item: { code: string; version: string; pdfBase64?: string } = {
        code: doc.code,
        version: doc.version,
      }
      if (doc.kind === 'CONTRACT') {
        const blob = await buildContractPdfBlob({
          title: doc.title,
          version: doc.version,
          effective: docEffective(doc),
          body: doc.body,
          party: {
            storeName: form.storeName || form.bizName,
            ownerName: form.ownerName,
            bizNumber: form.bizNumber,
            address: form.address,
            addressDetail: form.addressDetail,
          },
          signature: signature.value,
          signerName: form.ownerName || form.managerName,
          electronicMethod: true,
        })
        item.pdfBase64 = await blobToBase64(blob)
      }
      accepts.push(item)
    }

    const next = await submitSellerOnboarding({
      storeName: form.storeName,
      bizName: form.bizName,
      bizNumber: form.bizNumber,
      ownerName: form.ownerName,
      managerName: form.managerName,
      email: form.email,
      phone: form.phone,
      zipcode: form.zipcode,
      address: form.address,
      addressDetail: form.addressDetail,
      settleBank: form.settleBank,
      settleAccount: form.settleAccount,
      settleHolder: form.settleHolder,
      newPassword: pwTemp.value ? form.newPassword : undefined,
      signature: signature.value,
      accepts,
    })
    setSeller(next)
    window.alert('검수 요청이 접수되었습니다.\n관리자 승인 후 판매관리센터에서 상품을 등록할 수 있습니다.')
    await router.replace('/seller')
  } catch (error) {
    window.alert(error instanceof Error ? error.message : '제출에 실패했습니다.')
  } finally {
    submitting.value = false
  }
}

onMounted(() => {
  if (!seller.value) {
    router.replace({ name: 'login', query: { tab: 'seller', redirect: '/seller/onboarding' } })
    return
  }
  load()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[20] || (_cache[20] = _createElementVNode("p", { class: "sonb__eyebrow" }, "판매업체 입점", -1)),
      _cache[21] || (_cache[21] = _createElementVNode("h1", null, "정보 등록 · 약관 · 계약 서명", -1)),
      _createElementVNode("p", null, _toDisplayString(intro.value), 1),
      _createElementVNode("ol", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: step.key,
            class: "sonb__step"
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(index + 1), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(step.label), 1)
          ]))
        }), 128))
      ]),
      _cache[22] || (_cache[22] = _createElementVNode("p", { class: "sonb__head-note" }, " 제출 후에도 바로 판매되지는 않습니다. 관리자 승인 후 상품 등록이 열립니다. ", -1))
    ]),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
          _createVNode(AppIcon, {
            icon: "mdi-alert-outline",
            size: 16
          }),
          _createTextVNode(" " + _toDisplayString(errorMessage.value), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("form", {
        class: "sonb__form",
        onSubmit: _withModifiers(onSubmit, ["prevent"])
      }, [
        (pwTemp.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(stepIndex('password')), 1),
                _createElementVNode("h2", _hoisted_11, _toDisplayString(stepLabel('password')), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[26] || (_cache[26] = _createElementVNode("p", { class: "sonb__section-lead" }, "관리자가 발급한 임시 비밀번호를 본인만 아는 비밀번호로 바꿔 주세요.", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { for: "ob-pw" }, "새 비밀번호", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "ob-pw",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.newPassword) = $event)),
                      type: "password",
                      class: "sui-input",
                      autocomplete: "new-password",
                      minlength: "8",
                      required: ""
                    }, null, 512), [
                      [_vModelText, form.newPassword]
                    ]),
                    _cache[24] || (_cache[24] = _createElementVNode("p", { class: "sui-hint" }, "영문·숫자 포함 8자 이상을 권장합니다.", -1))
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[25] || (_cache[25] = _createElementVNode("label", { for: "ob-pw2" }, "새 비밀번호 확인", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "ob-pw2",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.newPasswordConfirm) = $event)),
                      type: "password",
                      class: "sui-input",
                      autocomplete: "new-password",
                      minlength: "8",
                      required: ""
                    }, null, 512), [
                      [_vModelText, form.newPasswordConfirm]
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(stepIndex('profile')), 1),
            _createElementVNode("h2", _hoisted_19, _toDisplayString(stepLabel('profile')), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[39] || (_cache[39] = _createElementVNode("p", { class: "sonb__section-lead" }, " 함우리몰과 주문서에 노출되는 업체 정보입니다. 사업자등록증과 같게 맞추고, 담당자 이메일·휴대폰 인증을 모두 완료해 주세요. ", -1)),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[27] || (_cache[27] = _createElementVNode("label", { for: "ob-store" }, "업체명 (노출명)", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "ob-store",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.storeName) = $event)),
                  class: "sui-input",
                  required: ""
                }, null, 512), [
                  [_vModelText, form.storeName]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[28] || (_cache[28] = _createElementVNode("label", { for: "ob-owner" }, "대표자명", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "ob-owner",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.ownerName) = $event)),
                  class: "sui-input",
                  required: ""
                }, null, 512), [
                  [_vModelText, form.ownerName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[29] || (_cache[29] = _createElementVNode("label", { for: "ob-biz" }, "상호", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "ob-biz",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.bizName) = $event)),
                  class: "sui-input",
                  required: ""
                }, null, 512), [
                  [_vModelText, form.bizName]
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[30] || (_cache[30] = _createElementVNode("label", { for: "ob-bizno" }, "사업자등록번호", -1)),
                _createElementVNode("input", {
                  id: "ob-bizno",
                  value: form.bizNumber,
                  class: _normalizeClass(["sui-input", {
                  'is-invalid': Boolean(bizNumberError.value),
                  'is-valid': _unref(isBizNumberInputValid)(form.bizNumber),
                }]),
                  inputmode: "numeric",
                  maxlength: "12",
                  placeholder: "000-00-00000",
                  required: "",
                  onInput: onBizNumberInput
                }, null, 42, _hoisted_27),
                (bizNumberError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(bizNumberError.value), 1))
                  : (_unref(isBizNumberInputValid)(form.bizNumber))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_29, " 형식이 올바릅니다. "))
                    : (_openBlock(), _createElementBlock("p", _hoisted_30, "숫자만 넣으면 됩니다. 하이픈(-)은 알아서 들어갑니다."))
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _cache[31] || (_cache[31] = _createElementVNode("label", { for: "ob-manager" }, "담당자명", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "ob-manager",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.managerName) = $event)),
                class: "sui-input",
                required: ""
              }, null, 512), [
                [_vModelText, form.managerName]
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { for: "ob-email" }, "담당자 이메일", -1)),
              _createElementVNode("div", _hoisted_33, [
                _withDirectives(_createElementVNode("input", {
                  id: "ob-email",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.email) = $event)),
                  type: "email",
                  class: "sui-input",
                  autocomplete: "email",
                  placeholder: "seller@example.com",
                  required: "",
                  disabled: emailLocked.value
                }, null, 8, _hoisted_34), [
                  [_vModelText, form.email]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "sui-btn",
                  disabled: !_unref(isEmailValid)(form.email) || _unref(emailVerification).verified || _unref(emailVerification).sending || _unref(emailVerification).resendIn > 0,
                  onClick: sendEmailCode
                }, _toDisplayString(_unref(emailVerification).sendActionLabel('인증발송', '재발송')), 9, _hoisted_35)
              ]),
              (_unref(emailVerification).verified)
                ? (_openBlock(), _createElementBlock("p", _hoisted_36, "이메일 인증이 완료되었습니다."))
                : (_unref(emailVerification).codeSent)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(form.email) + "으로 인증번호를 보냈습니다. 받은편지함과 스팸함을 확인해 주세요. ", 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_38, "승인 결과와 새 주문·취소/반품처럼 바로 손봐야 하는 안내를 이 주소로 보냅니다. 인증이 필요합니다."))
            ]),
            (!_unref(emailVerification).verified && _unref(emailVerification).codeSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _cache[33] || (_cache[33] = _createElementVNode("label", { for: "ob-email-code" }, "이메일 인증번호", -1)),
                  _createElementVNode("div", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      id: "ob-email-code",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.emailCode) = $event)),
                      type: "text",
                      class: "sui-input",
                      inputmode: "numeric",
                      maxlength: "6",
                      placeholder: "인증번호 6자리",
                      onInput: _cache[8] || (_cache[8] = ($event: any) => (form.emailCode = _unref(sanitizeDigitsInput)(($event.target as HTMLInputElement).value, 6)))
                    }, null, 544), [
                      [_vModelText, form.emailCode]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "sui-btn",
                      disabled: !_unref(isVerifyCodeValid)(form.emailCode) || _unref(emailVerification).verifying,
                      onClick: confirmEmailCode
                    }, _toDisplayString(_unref(emailVerification).verifying ? '확인 중' : '확인'), 9, _hoisted_41)
                  ]),
                  _createElementVNode("p", {
                    class: _normalizeClass(["sui-hint", { 'sonb__verify-err': _unref(emailVerification).errorMessage }])
                  }, [
                    _createTextVNode(_toDisplayString(_unref(emailVerification).errorMessage || '메일함에서 인증번호를 확인해 주세요.') + " ", 1),
                    (_unref(emailVerification).timer > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_unref(emailVerification).formatTimer(_unref(emailVerification).timer)), 1))
                      : _createCommentVNode("", true)
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_43, [
              _cache[34] || (_cache[34] = _createElementVNode("label", { for: "ob-phone" }, "대표 연락처", -1)),
              _createElementVNode("div", _hoisted_44, [
                _withDirectives(_createElementVNode("input", {
                  id: "ob-phone",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.phone) = $event)),
                  type: "tel",
                  class: "sui-input",
                  inputmode: "numeric",
                  autocomplete: "tel",
                  maxlength: "11",
                  placeholder: "숫자만 입력",
                  required: "",
                  disabled: phoneLocked.value,
                  onInput: _cache[10] || (_cache[10] = ($event: any) => (form.phone = _unref(sanitizeDigitsInput)(($event.target as HTMLInputElement).value, 11)))
                }, null, 40, _hoisted_45), [
                  [_vModelText, form.phone]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "sui-btn",
                  disabled: !_unref(isPhoneValid)(form.phone) || _unref(phoneVerification).verified || _unref(phoneVerification).sending || _unref(phoneVerification).resendIn > 0,
                  onClick: sendPhoneCode
                }, _toDisplayString(_unref(phoneVerification).sendActionLabel('인증발송', '재발송')), 9, _hoisted_46)
              ]),
              (_unref(phoneVerification).verified)
                ? (_openBlock(), _createElementBlock("p", _hoisted_47, "휴대폰 인증이 완료되었습니다."))
                : (_openBlock(), _createElementBlock("p", _hoisted_48, "구매자 문의·주문 알림에 사용됩니다. 인증이 필요합니다."))
            ]),
            (!_unref(phoneVerification).verified && _unref(phoneVerification).codeSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _cache[35] || (_cache[35] = _createElementVNode("label", { for: "ob-phone-code" }, "휴대폰 인증번호", -1)),
                  _createElementVNode("div", _hoisted_50, [
                    _withDirectives(_createElementVNode("input", {
                      id: "ob-phone-code",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.phoneCode) = $event)),
                      type: "text",
                      class: "sui-input",
                      inputmode: "numeric",
                      maxlength: "6",
                      placeholder: "인증번호 6자리",
                      onInput: _cache[12] || (_cache[12] = ($event: any) => (form.phoneCode = _unref(sanitizeDigitsInput)(($event.target as HTMLInputElement).value, 6)))
                    }, null, 544), [
                      [_vModelText, form.phoneCode]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "sui-btn",
                      disabled: !_unref(isVerifyCodeValid)(form.phoneCode) || _unref(phoneVerification).verifying,
                      onClick: confirmPhoneCode
                    }, _toDisplayString(_unref(phoneVerification).verifying ? '확인 중' : '확인'), 9, _hoisted_51)
                  ]),
                  _createElementVNode("p", {
                    class: _normalizeClass(["sui-hint", { 'sonb__verify-err': _unref(phoneVerification).errorMessage }])
                  }, [
                    _createTextVNode(_toDisplayString(_unref(phoneVerification).errorMessage || '문자로 받은 인증번호를 입력해 주세요.') + " ", 1),
                    (_unref(phoneVerification).timer > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_unref(phoneVerification).formatTimer(_unref(phoneVerification).timer)), 1))
                      : _createCommentVNode("", true)
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _cache[36] || (_cache[36] = _createElementVNode("label", { for: "ob-zip" }, "우편번호", -1)),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("input", {
                    id: "ob-zip",
                    value: form.zipcode,
                    class: "sui-input",
                    placeholder: "주소 검색",
                    readonly: "",
                    onClick: onSearchAddress
                  }, null, 8, _hoisted_56),
                  _createElementVNode("button", {
                    type: "button",
                    class: "sui-btn",
                    disabled: _unref(postcodeOpening),
                    onClick: onSearchAddress
                  }, " 주소 검색 ", 8, _hoisted_57)
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _cache[37] || (_cache[37] = _createElementVNode("label", { for: "ob-addr" }, "출고지 주소", -1)),
                _createElementVNode("input", {
                  id: "ob-addr",
                  value: form.address,
                  class: "sui-input",
                  placeholder: "주소 검색을 눌러 주세요",
                  readonly: "",
                  onClick: onSearchAddress
                }, null, 8, _hoisted_59)
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _cache[38] || (_cache[38] = _createElementVNode("label", { for: "ob-addr2" }, "상세 주소", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "ob-addr2",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.addressDetail) = $event)),
                class: "sui-input",
                placeholder: "동·호수 등"
              }, null, 512), [
                [_vModelText, form.addressDetail]
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("span", _hoisted_63, _toDisplayString(stepIndex('bank')), 1),
            _createElementVNode("h2", _hoisted_64, _toDisplayString(stepLabel('bank')), 1)
          ]),
          _createElementVNode("div", _hoisted_65, [
            _cache[44] || (_cache[44] = _createElementVNode("p", { class: "sonb__section-lead" }, "정산금이 입금될 계좌입니다. 예금주는 사업자등록증 상호와 같아야 합니다.", -1)),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _cache[41] || (_cache[41] = _createElementVNode("label", { for: "ob-bank" }, "은행", -1)),
                _withDirectives(_createElementVNode("select", {
                  id: "ob-bank",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.settleBank) = $event)),
                  class: "sui-select",
                  required: ""
                }, [
                  _cache[40] || (_cache[40] = _createElementVNode("option", { value: "" }, "선택해 주세요", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BANKS), (bank) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: bank,
                      value: bank
                    }, _toDisplayString(bank), 9, _hoisted_68))
                  }), 128))
                ], 512), [
                  [_vModelSelect, form.settleBank]
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _cache[42] || (_cache[42] = _createElementVNode("label", { for: "ob-acc" }, "계좌번호", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "ob-acc",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.settleAccount) = $event)),
                  class: "sui-input",
                  inputmode: "numeric",
                  required: ""
                }, null, 512), [
                  [_vModelText, form.settleAccount]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _cache[43] || (_cache[43] = _createElementVNode("label", { for: "ob-holder" }, "예금주", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "ob-holder",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.settleHolder) = $event)),
                class: "sui-input",
                required: ""
              }, null, 512), [
                [_vModelText, form.settleHolder]
              ])
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_71, [
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("span", _hoisted_73, _toDisplayString(stepIndex('terms')), 1),
            _createElementVNode("h2", _hoisted_74, _toDisplayString(stepLabel('terms')), 1)
          ]),
          _createElementVNode("div", _hoisted_75, [
            _cache[46] || (_cache[46] = _createElementVNode("p", { class: "sonb__section-lead" }, "필수 이용약관을 펼쳐 확인한 뒤 각각 동의해 주세요. 체크는 미리 선택되지 않습니다.", -1)),
            (termDocs.value.length)
              ? (_openBlock(), _createElementBlock("label", _hoisted_76, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((acceptAllTerms).value = $event)),
                    type: "checkbox",
                    onChange: onAcceptAllTerms
                  }, null, 544), [
                    [_vModelCheckbox, acceptAllTerms.value]
                  ]),
                  _cache[45] || (_cache[45] = _createTextVNode(" 필수 약관 전체 동의 ", -1))
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(termDocs.value, (doc) => {
              return (_openBlock(), _createElementBlock("details", {
                key: doc.code,
                class: "sonb__doc"
              }, [
                _createElementVNode("summary", null, [
                  _createElementVNode("span", null, [
                    _createElementVNode("strong", null, _toDisplayString(doc.title), 1),
                    _createElementVNode("em", null, "v" + _toDisplayString(doc.version), 1)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["sonb__doc-state", { 'is-on': accepted[doc.code] }])
                  }, _toDisplayString(accepted[doc.code] ? '동의함' : '확인 필요'), 3)
                ]),
                _createElementVNode("pre", _hoisted_77, _toDisplayString(doc.body), 1),
                _createElementVNode("label", {
                  class: "sonb__check",
                  onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((accepted[doc.code]) = $event),
                    type: "checkbox",
                    onClick: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, _hoisted_78), [
                    [_vModelCheckbox, accepted[doc.code]]
                  ]),
                  _createTextVNode(" " + _toDisplayString(doc.title) + "에 동의합니다 ", 1)
                ])
              ]))
            }), 128)),
            (!termDocs.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_79, "등록된 이용약관이 없습니다. 관리자에게 문의해 주세요."))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("section", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("span", _hoisted_82, _toDisplayString(stepIndex('contract')), 1),
            _createElementVNode("h2", _hoisted_83, _toDisplayString(stepLabel('contract')), 1)
          ]),
          _createElementVNode("div", _hoisted_84, [
            _cache[47] || (_cache[47] = _createElementVNode("p", { class: "sonb__section-lead" }, " 약관 동의 후 공급·판매운영 기본계약서를 조·별첨별로 확인하고, 각 섹션과 전자계약 방식에 체크한 뒤 PDF로 저장할 수 있습니다. ", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contractDocs.value, (doc) => {
              return (_openBlock(), _createBlock(ContractDocumentView, {
                key: doc.code,
                mode: "agree",
                title: doc.title,
                version: doc.version,
                effective: docEffective(doc),
                body: doc.body,
                party: {
              storeName: form.storeName || form.bizName,
              ownerName: form.ownerName,
              bizNumber: form.bizNumber,
              address: form.address,
              addressDetail: form.addressDetail,
            },
                "onUpdate:ready": (ready) => onContractReady(doc.code, ready),
                "onUpdate:checks": (items) => onContractChecks(doc.code, items)
              }, null, 8, ["title", "version", "effective", "body", "party", "onUpdate:ready", "onUpdate:checks"]))
            }), 128)),
            (!contractDocs.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_85, "등록된 계약서가 없습니다. 관리자에게 문의해 주세요."))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("section", _hoisted_86, [
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("span", _hoisted_88, _toDisplayString(stepIndex('signature')), 1),
            _createElementVNode("h2", _hoisted_89, _toDisplayString(stepLabel('signature')), 1)
          ]),
          _createElementVNode("div", _hoisted_90, [
            _cache[48] || (_cache[48] = _createElementVNode("p", { class: "sonb__section-lead" }, " 위 약관·계약서에 대한 동의 의사로 대표자 또는 계약권한자가 서명해 주세요. 서명·문서 버전·시각이 저장됩니다. ", -1)),
            _createVNode(SignaturePad, {
              size: "lg",
              onChange: onSignature
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_91, [
          _cache[49] || (_cache[49] = _createElementVNode("div", { class: "sonb__actions-copy" }, [
            _createElementVNode("strong", null, "제출하면 검수 대기(PENDING) 상태가 됩니다."),
            _createElementVNode("span", null, "관리자 승인 전에는 상품 등록·판매를 할 수 없습니다.")
          ], -1)),
          _createElementVNode("button", {
            type: "submit",
            class: "sui-btn sui-btn--primary sonb__submit",
            disabled: submitting.value
          }, _toDisplayString(submitting.value ? '제출 중…' : '검수 요청하기'), 9, _hoisted_92)
        ])
      ], 32),
      _createElementVNode("aside", _hoisted_93, [
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("header", _hoisted_95, [
            _cache[50] || (_cache[50] = _createElementVNode("strong", null, "입력 확인", -1)),
            _createElementVNode("span", null, _toDisplayString(checklistDoneCount.value) + "/" + _toDisplayString(checklist.value.length), 1)
          ]),
          _cache[51] || (_cache[51] = _createElementVNode("p", { class: "sonb__tracker-lead" }, "항목을 누르면 해당 입력으로 이동합니다.", -1)),
          _createElementVNode("ul", _hoisted_96, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checklist.value, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.key,
                class: _normalizeClass(["sonb__tracker-item", { 'is-done': item.done }])
              }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: ($event: any) => (scrollToChecklistItem(item))
                }, [
                  _createElementVNode("span", _hoisted_98, [
                    (item.done)
                      ? (_openBlock(), _createBlock(AppIcon, {
                          key: 0,
                          icon: "mdi-check",
                          size: 14
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_99, _toDisplayString(item.label), 1)
                ], 8, _hoisted_97)
              ], 2))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})